export { default, getServerSideProps } from "src/pages/User/UserDonationPage";
